import th from "@/app/locales/th.json";
import en from "@/app/locales/en.json";

export default { en, th };
